import { kInternal } from '@liveblocks/core';
import { useClient } from '@liveblocks/react';
import { useSignal } from '@liveblocks/react/_private';

function useCurrentUserId() {
  const client = useClient();
  return useSignal(client[kInternal].currentUserId) ?? null;
}

export { useCurrentUserId };
//# sourceMappingURL=shared.js.map
